import axios from 'axios'
import { AuthMethod } from '@/dto/AuthMethod'
import User from '@/dto/User'

const LoginService = {
  login(phone: string, password: string): Promise<string> {
    return axios
      .post('/login', { phone: formatPhoneToNumber(phone), password })
      .then(response => response.data.url)
  },
  getAuthMethodByPhone(phone: string): Promise<AuthMethod> {
    return axios
      .post(`/auth-method`, { phone: formatPhoneToNumber(phone) })
      .then(response => response.data.authMethod)
  },
  getCurrentUser(): Promise<User> {
    return axios
      .get(`/user`)
      .then(response => response.data.user)
      .catch(error => {
        throw error.response.data.errors
      })
  },
}

function formatPhoneToNumber(phone: string): string {
  return phone.replace(/[^\d]/g, '')
}

export default LoginService
